var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailableRooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 5,
    fill: "#ECFFE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.672 13.464L15.4 18.736L12.528 15.872L11.4 17L15.4 21L21.8 14.6L20.672 13.464ZM17 9C12.584 9 9 12.584 9 17C9 21.416 12.584 25 17 25C21.416 25 25 21.416 25 17C25 12.584 21.416 9 17 9ZM17 23.4C13.464 23.4 10.6 20.536 10.6 17C10.6 13.464 13.464 10.6 17 10.6C20.536 10.6 23.4 13.464 23.4 17C23.4 20.536 20.536 23.4 17 23.4Z",
    fill: "#7CB966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableRooms);
export default __webpack_public_path__ + "static/media/available_rooms.a9f963f3d2c0ad3b2d9427aa675fc6f3.svg";
export { ForwardRef as ReactComponent };